import AddNotificationModal from "../Modals/Add_Notification_Modal";
import {AddNotificationModalBody} from "./addNotificationModalBody";
import React from "react";

export function AddNotification(props) {
    return <AddNotificationModal
        isOpen={props.open}
        handleClose={props.handleClose}
        handleSaveNotification={props.handleSaveNotification}
        handleAPICall={props.handleAPICall}
    >
        <AddNotificationModalBody activeTab={props.activeTab} onClick={props.onClick}
                                  onClick1={props.onClick1} value={props.value}
                                  onChange={props.onChange}/>
    </AddNotificationModal>;
}